var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000312805 4.84735L0.108854 0.914709C0.120972 0.474978 0.474927 0.12104 0.914707 0.108869L4.8476 0.000332322C5.07734 -0.00609206 5.2947 0.0808404 5.45667 0.242805L11.7576 6.54342C12.0808 6.86665 12.0808 7.39255 11.7576 7.71578L7.71616 11.757C7.39219 12.081 6.86778 12.081 6.54372 11.757L0.242797 5.4564C0.0824499 5.29603 -0.00594997 5.07402 0.000312805 4.84735ZM1.80107 3.79443C2.352 4.3453 3.24365 4.34536 3.7946 3.79443C4.34422 3.24484 4.34422 2.35057 3.7946 1.801C3.24367 1.25011 2.35202 1.25008 1.80107 1.801C1.25147 2.35057 1.25147 3.24484 1.80107 3.79443Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingTag);
export default __webpack_public_path__ + "static/media/shopping-tag.b93a964dd022054bb169bf88fcbee327.svg";
export { ForwardRef as ReactComponent };